import {Route, Routes} from "react-router-dom";

import DataIntegrationCreateScreen from "screens/App/CRM/DataIntegration/DataIntegrationCreateScreen";
import DataIntegrationListScreen from "screens/App/CRM/DataIntegration/DataIntegrationListScreen";
import DataIntegrationInfoScreen from "screens/App/CRM/DataIntegration/DataIntegrationInfoScreen";
import DataIntegrationDetailScreen from "screens/App/CRM/DataIntegration/DataIntegrationDetailScreen";
import DataIntegrationEditScreen from "screens/App/CRM/DataIntegration/DataIntegrationEditScreen";
import NotFoundScreen from "screens/NotFoundScreen";

const DataIntegrationRouter = () => {
    return (
        <Routes>
            <Route path= "create" element={<DataIntegrationCreateScreen />} />
            <Route path= "list" element={<DataIntegrationListScreen />} />
            <Route path= ":id/detail" element={<DataIntegrationDetailScreen />} />
            <Route path= ":id/edit" element={<DataIntegrationEditScreen />} />
            <Route path= "info" element={<DataIntegrationInfoScreen />} />
            <Route path= "*" element={<NotFoundScreen />} />
        </Routes>
    );
};

export default DataIntegrationRouter;